/* This component UPDATES one entry in the historys collection in MongoDB.
   This component should use the HistoryRead component to showw the items
   available for UPDATE. This compoent should allow for deletion of any
   entry in the selected history entry. HistoryDelete should only be used
   to delete an entire history entry in MongoDB. */

import React                                 from 'react'
import axios                                 from 'axios'
import Box                                   from "@material-ui/core/Box"
import Grid                                  from "@material-ui/core/Grid"
import Paper                                 from "@material-ui/core/Paper"
import PropTypes                             from 'prop-types'
import Typography                            from "@material-ui/core/Typography"

const HistoryUpdateComponent = ({ handleShow }) => {

   return (
      <Box>

      </Box>
   )
}

HistoryUpdateComponent.propTypes = {
    handleSubmit:     PropTypes.func
}

export default HistoryUpdateComponent
